import React, { BaseSyntheticEvent } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { IOption } from '../../../common/common.types'
import SingleSelectPage from '../../../components/singleSelectPage/SingleSelectPage.component'
import { useTranslation } from 'react-i18next'
import { getAddMedicationAdministeredSelector } from '../selectors'
import {
  saveMedicationAdministered,
  setCurrentMedication,
  setMedication,
} from '../store/addMedicationAdministered.actions'
import { getAddMedicationAdministeredOptionsSelector } from '../../options/selectors'
import { useIonViewDidEnter } from '@ionic/react'
import { setIsFirstVisit } from '../../../components/procedure/store/procedure.actions'
import { goBack } from '../../../utilities/navigation.util'

const MedicationAdministeredSearch: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const addMedicationAdministeredState = useSelector(getAddMedicationAdministeredSelector)
  const addMedicationAdministeredOptionsState = useSelector(getAddMedicationAdministeredOptionsSelector)
  const { medicationAdministered, areMedicationsOptionsLoading } = addMedicationAdministeredState
  const { medicationsOptions } = addMedicationAdministeredOptionsState

  const onBackClick = () => {
    goBack()
    dispatch(setCurrentMedication(medicationAdministered))
  }

  const setSelectedName = (e: BaseSyntheticEvent, option: IOption) => {
    e.preventDefault()
    dispatch(setMedication(option, medicationAdministered))
    dispatch(setCurrentMedication(medicationAdministered))
    dispatch(saveMedicationAdministered())
    dispatch(setIsFirstVisit(true))
    onBackClick()
  }

  useIonViewDidEnter(() => {
    dispatch(setIsFirstVisit(false))
  })

  return (
    <SingleSelectPage
      selectedOption={medicationAdministered ? medicationAdministered.medication : null}
      options={medicationsOptions}
      action={setSelectedName}
      backAction={onBackClick}
      dividerText={t('patientMedications.tapToAddMedicationToCurrentPatient')}
      loading={areMedicationsOptionsLoading}
      listHeader={'Current Medications'}
    />
  )
}

export default MedicationAdministeredSearch
